module.exports = __webpack_public_path__ + "static/media/logo_white.1585ec55.png";